import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import AdminUsers from "@/pages/admin/Users";
import AdminRoles from "@/pages/admin/Roles";
import AdminModules from "@/pages/admin/Modules";
import AdminCompanies from "@/pages/admin/Companies";
import AdminData from "@/pages/admin/Data";
import AdminTrash from "@/pages/admin/Trash";
import { AdminGlobal, AdminAudit } from "@/pages/admin/Global";

const TABS = [["users", "Utilisateurs et rôles", AdminUsers], ["roles", "Rôles et permissions", AdminRoles], ["modules", "Modules", AdminModules],
  ["companies", "Sociétés", AdminCompanies], ["data", "Données", AdminData], ["trash", "Corbeille", AdminTrash], ["global", "Paramètres globaux", AdminGlobal], ["audit", "Journal d'audit", AdminAudit]];

export default function AdminPage() {
  const { user } = useAuth();
  const [tab, setTab] = useState("users");
  if (user.role !== "superadmin" || user._readonly) return <Navigate to="/" replace />;
  const Cur = TABS.find((t) => t[0] === tab)[2];
  return (
    <div data-testid="admin-page">
      <PageHeader title="Administration" subtitle="Accès complet à toutes les sociétés et tous les services. Chaque action est tracée dans le journal d'audit." />
      <div className="mb-6 flex flex-wrap gap-1 border-b border-[#E4E4EC]">
        {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`} className={`-mb-px border-b-2 px-4 py-2 text-sm font-semibold ${tab === k ? "border-[#A5894E]" : "border-transparent text-[#6B6B80]"}`}>{l}</button>)}
      </div>
      <Cur />
    </div>
  );
}
